import { usePublicIsLogged, usePublicSignOut } from '@/hooks/usePoleasPublic'
import { isIn } from 'BrokerTsLib/src/Utils/comparisonUtils'
import { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { AuthContext } from './AuthContext'

export const PoleasPublicAuthProvider = ({ children }: { children: React.ReactNode }) => {
  const { data: user, isLoading, error, refetch } = usePublicIsLogged()
  const { mutateAsync: logoutAsync, isPending: isLoggingOut } = usePublicSignOut()

  const navigate = useNavigate()
  const logout = useCallback(async () => {
    await logoutAsync()
    navigate('/poleas/logout')
  }, [logoutAsync, navigate])

  useEffect(() => {
    if (error && !isIn(error?.code, 'ERR_NETWORK', 'ECONNABORTED', 'ERR_CANCELED'))
      logout()
  }, [error, logout])

  const reload = useCallback(() => {
    refetch()
  }, [refetch])

  return (

    <AuthContext.Provider value={{
      isLoading,
      user: user ?? null,
      setReadMessage: () => { },
      logout,
      isLoggingOut,
      reload
    }}>
      {children}
    </AuthContext.Provider>
  )
}